module.exports = __webpack_public_path__ + "img/daniRx2.5d4f566f.jpg";